import { render, staticRenderFns } from "./kitchen.vue?vue&type=template&id=3d060262"
import script from "./kitchen.vue?vue&type=script&lang=js"
export * from "./kitchen.vue?vue&type=script&lang=js"
import style0 from "./kitchen.vue?vue&type=style&index=0&id=3d060262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports